import { AbilityProvider } from './components/Ability';
import { NotistackProvider } from './components/NotistackProvider';
import { Router } from './routes';

export const App = () => (
  <AbilityProvider>
    <NotistackProvider>
      <Router />
    </NotistackProvider>
  </AbilityProvider>
);
